import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import UpdateRepository from '../Repositories/UpdateRepository'


class UpdateBloc {

    updateChannel = new Subject();
    detailChannel = new Subject();
    repository = new UpdateRepository()
    listPegawaiChanel = new Subject()
    listHukumanChanel = new Subject()
   
   
    constructor() {
        this.updateChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetail = async (query) => {
        this.detailChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetail(query).then((result) => {
            this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.detailChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchUpdate = async (query) => {
        this.updateChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchUpdate(query).then((result) => {
            this.updateChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.updateChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

   fetchPegawai = async (query) => {
        this.listPegawaiChanel.next({status: apiResponse.LOADING})
        await this.repository.fetchPegawai(query).then((result) => {
            this.listPegawaiChanel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.listPegawaiChanel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchHukuman = async (query) => {
        this.listHukumanChanel.next({status: apiResponse.LOADING})
        await this.repository.fetchHukuman(query).then((result) => {
            this.listHukumanChanel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.listHukumanChanel.next({status: apiResponse.ERROR, data: error})
        })
    }

}

export default UpdateBloc